import { RouteHttpVerb } from "@devowl-wp/utils";
export const locationRestScannerResultAllExternalUrlsByHostGet = {
    path: "/scanner/result/externals/:type/:identifier",
    method: RouteHttpVerb.GET,
    obfuscatePath: "full"
};
